import React from "react";
import Logger from "../utils/Logger";
import g from "../utils/globals";
import Dynamic from "./Dynamic";
import { sendProductAnalytics } from "../utils/analytics";
import "../../css/components/Tree.scss";

const logger = new Logger(__filename);

class Tree extends React.Component {
  constructor(props) {
    super(props);
    this.appRef = React.createRef();
    this.enhancementTimeout = null;
    this.productsImpressionsToSend = new Map();
  }

  componentDidMount = () => {
    if (this.props.willDuplicate && !this.props.clone) {
      this.props.saveProps(this.props.willDuplicate, this.props);
    }
    if (this.props.enhancement && !this.props.enhancement.Content) {
      this.loadEnhancement(this.props.enhancement, true);
      const fileName = this.props.dataAttrs["data-content"];
      const contentEnhancement = this.props.enhancement[fileName] || {};
      this.loadEnhancement(contentEnhancement);
    }
  };

  componentDidUpdate = () => {
    if (g.enhancementsLoaded.includes(this.props.attrs.id)) {
      g.enhancementsLoaded = g.enhancementsLoaded.filter(enhancement => enhancement !== this.props.attrs.id);
    }
    if (this.props.willDuplicate && !this.props.clone) {
      this.props.saveProps(this.props.willDuplicate, this.props);
    }
    if (this.props.enhancement && !this.props.enhancement.Content) {
      this.props.enhancement.dispose();
      this.restartEnhancement();
      window.addEventListener("resize", this.restartEnhancement);
    }
  };

  restartEnhancement = () => {
    clearTimeout(this.enhancementTimeout);
    this.enhancementTimeout = setTimeout(() => {
      this.loadEnhancement(this.props.enhancement, true);
      const fileName = this.props.dataAttrs["data-content"];
      const contentEnhancement = this.props.enhancement[fileName] || {};
      this.loadEnhancement(contentEnhancement);
      window.removeEventListener("resize", this.restartEnhancement);
    }, 100);
  };

  loadEnhancement = (fn, once = false) => {
    if (!fn || !fn.init) return;
    if (!once || !g.enhancementsLoaded.includes(this.props.attrs.id)) {
      try {
        fn.init(this);
        logger.log(`... enhancing content [${this.props.attrs.id}]`);
        if (once) {
          g.enhancementsLoaded.push(this.props.attrs.id);
        }
      } catch (error) {
        logger.error(`Enhancement error: ${this.props.attrs.id}`);
        logger.debug(error);
      }
    }
  };

  getEnhancementProps = () => {
    const enhancementProps = {};
    if (this.props.enhancement && !this.props.enhancement.Content) {
      const fileName = this.props.dataAttrs["data-content"];
      const contentEnhancement = this.props.enhancement[fileName] || {};
      if (this.props.enhancement) {
        enhancementProps.noLazy = this.props.enhancement?.noLazy || contentEnhancement.noLazy;
        enhancementProps.staticVideos = this.props.enhancement.staticVideos || contentEnhancement.staticVideos;
        enhancementProps.playingVideos = this.props.enhancement.playingVideos || contentEnhancement.playingVideos;
        enhancementProps.singleQualityVideos = this.props.enhancement.singleQualityVideos || contentEnhancement.singleQualityVideos;
      }
    }
    return enhancementProps;
  };

  addProductImpressionsToSend = (productId, impressionData) => {
    clearTimeout(this.productImpressionsTimeout);
    this.productsImpressionsToSend.set(productId, impressionData);
    this.productImpressionsTimeout = setTimeout(() => {
      this.sendProductImpressions();
    }, 300);
  };

  sendProductImpressions = () => {
    sendProductAnalytics("PRODUCT_IMPRESSION", Array.from(this.productsImpressionsToSend.values()));
    this.productsImpressionsToSend.clear();
  };

  render() {
    const {
      contents,
      customProps: { wrappedItems },
    } = this.props;

    const enhancementProps = this.getEnhancementProps();

    const renderElement = (elm, index, insideLink) => {
      if (elm.dataAttrs) {
        elm.dataAttrs["data-content"] = this.props.dataAttrs ? this.props.dataAttrs["data-content"] : "";
      }
      if (elm.id === "placeholder") {
        elm.module = "HTML";
        elm.attrs = {};
      }
      if (elm.module === "Img" || elm.module === "Video" || elm.module === "Carousel") {
        elm.carousel = this.props.carousel;
      }
      if (elm.children?.length) {
        const linkChildren = elm.module === "Link" || insideLink;
        return (
          <Dynamic key={`${elm.id}-${index}`} {...elm} {...enhancementProps} addProductImpressionsToSend={this.addProductImpressionsToSend}>
            {elm.children.map((e, idx) => renderElement(e, idx, linkChildren))}
          </Dynamic>
        );
      }
      if (wrappedItems || elm.attributes?.social) {
        return (
          <div key={`${elm.id}-${index}`} style={{ position: "relative", ...elm.styles }} id={`${elm.id}-layout-item-wrapped`}>
            <Dynamic
              {...elm}
              styles={{}}
              {...enhancementProps}
              insideLink={insideLink}
              addProductImpressionsToSend={this.addProductImpressionsToSend}
            />
          </div>
        );
      }
      return (
        <Dynamic
          key={`${elm.id}-${index}`}
          {...elm}
          {...enhancementProps}
          insideLink={insideLink}
          addProductImpressionsToSend={this.addProductImpressionsToSend}
        />
      );
    };

    return contents?.map((elm, idx) => renderElement(elm, idx));
  }
}

export default Tree;
